<template>
  <div
    class="result-list-scroller">
    <button
      class="arrow-button"
      @click="onClickPrev">
      <b-icon-triangle-fill
        class="arrow-icon" />
    </button>
    <span class="counts">{{ counts }} 件</span>
    <button
      class="arrow-button"
      @click="onClickNext">
      <b-icon-triangle-fill
        class="arrow-icon"
        flip-v />
    </button>
    <button
      class="close-button"
      @click="onClickClose">
      <b-icon-x />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    counts: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    onClickPrev() {
      this.$emit('onClickPrev')
    },
    onClickNext() {
      this.$emit('onClickNext')
    },
    onClickClose() {
      this.$emit('onClickClose')
    }
  }
}
</script>

<style lang="scss" scoped>
.result-list-scroller {
  position: fixed;
  background-color: $white;
  padding: 10px 0;
  border-radius: 8px;
  border: solid 2px $l-blue;
  color: $l-blue;
  display: flex;
  align-items: center;
  min-width: 50px;
  justify-content: space-evenly;
  flex-direction: column;

  .arrow-button {
    color: $l-blue;
    padding: 0 10px;
    height: 30px;
    border: none;
    background: $white;
    display: flex;
    align-items: center;
  }

  .counts {
    padding: 0 5px;
  }

  .close-button {
    border: solid 1px $l-blue;
    background: $white;
    color: $l-blue;
    padding: 0;
    position: absolute;
    top: -15px;
    right: -15px;
    width: 28px;
    height: 28px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
}
</style>

<style lang="scss">
.result-list-scroller {
  .arrow-icon {
    font-size: $fs-s;
  }

  .close-button {
    font-size: $fs-xxl;
  }
}
</style>